<template>
    <div class="main-content-container p-4">
        <h3 class="page-title">
            UTM URL builder
        </h3>
        <d-card class="mt-4">
            <d-card-body>
                <utm-input-field />
            </d-card-body>
        </d-card>
        <d-card class="mt-4">
            <d-card-body>
                <utm-link-generator />
            </d-card-body>
        </d-card>
    </div>
</template>
<script>
    import UtmInputField from './UtmInputFields.vue';
    import UtmLinkGenerator from './UtmLinkGenerator.vue';

    export default {
        components: {
            UtmInputField,
            UtmLinkGenerator
        }
    }
</script>